<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title">CONTENTS</h1>
<p class="toc-fm"><a href="#/006_Foreword#fm-1"><em>Foreword</em> by Frank Schaeffer</a></p>
<p class="toc-fm"><a href="#/007_Introduction#fm-2">Introduction: Fun at Parties</a></p>
<p class="toc-chap"><span class="sp"><a href="#/008_Chapter01#ch-1">1.<span class="pad">Into the Desert We Go</span></a></span></p>
<p class="toc-chap"><span class="sp"><span href="#/009_Chapter02#ch-2" title="Link target outside of Sample">2.<span class="pad">One of Us</span></span></span></p>
<p class="toc-chap"><span class="sp"><span href="#/010_Chapter03#ch-3" title="Link target outside of Sample">3.<span class="pad">Immigration—the Legal Drama</span></span></span></p>
<p class="toc-chap"><span class="sp"><span href="#/011_Chapter04#ch-4" title="Link target outside of Sample">4.<span class="pad">An Immigration Autobiography</span></span></span></p>
<p class="toc-chap"><span class="sp"><span href="#/012_Chapter05#ch-5" title="Link target outside of Sample">5.<span class="pad">Critical Race Theory—the Mockumentary</span></span></span></p>
<p class="toc-chap"><span class="sp"><span href="#/013_Chapter06#ch-6" title="Link target outside of Sample">6.<span class="pad">A Critical Race Theory Memorial</span></span></span></p>
<p class="toc-chap"><span class="sp"><span href="#/014_Chapter07#ch-7" title="Link target outside of Sample">7.<span class="pad">Abortion—the Historical Fiction</span></span></span></p>
<p class="toc-chap"><span class="sp"><span href="#/015_Chapter08#ch-8" title="Link target outside of Sample">8.<span class="pad">An Abortion Lament</span></span></span></p>
<p class="toc-chap"><span class="sp"><span href="#/016_Chapter09#ch-9" title="Link target outside of Sample">9.<span class="pad">Climate Change—the Speculative Dystopian Thriller Series</span></span></span></p>
<p class="toc-chap"><span href="#/017_Chapter10#ch-10" title="Link target outside of Sample">10.<span class="pad">A Climate Change Survival Epic</span></span></p>
<p class="toc-chap"><span href="#/018_Chapter11#ch-11" title="Link target outside of Sample">11.<span class="pad">COVID-19—the Lost Plot</span></span></p>
<p class="toc-chap"><span href="#/019_Chapter12#ch-12" title="Link target outside of Sample">12.<span class="pad">An Alternative Pandemic Mythology</span></span></p>
<p class="toc-chap"><span href="#/020_Chapter13#ch-13" title="Link target outside of Sample">13.<span class="pad">Mass Shootings—the Murder Mystery</span></span></p>
<p class="toc-chap"><span href="#/021_Chapter14#ch-14" title="Link target outside of Sample">14.<span class="pad">An Ode to Nonviolence</span></span></p>
<p class="toc-chap"><span href="#/022_Chapter15#ch-15" title="Link target outside of Sample">15.<span class="pad">Turning the Story Inside Out</span></span></p>
<p class="toc-bmt"><span href="#/023_Ack#bm-1" title="Link target outside of Sample"><em>Acknowledgments</em></span></p>
<p class="toc-bm0"><span href="#/024_Notes#bm-2" title="Link target outside of Sample"><em>Notes</em></span></p>
<p class="toc-bm0"><span href="#/025_Bib#bm-3" title="Link target outside of Sample"><em>Selected Bibliography</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005_Contents.vue?6945bbba